import circuitBreaker from './circuitBreaker'
import { type GlobalElementsApiOptions } from './types'

export const fetchGeDataWithCircuitBreaker = async (geApiOpts: GlobalElementsApiOptions) => {
  return await circuitBreaker.fire(geApiOpts)
}
